const clampArray = (arr, min, max) => {
  return arr.map((v) => Math.max(min, Math.min(max, v)))
}

export const getWindBinData = async (url, zoom, bounds) => {
  const requestUrl = url.replace('{z}', Math.floor(zoom))
    .replace('{w}', bounds.getWest())
    .replace('{s}', bounds.getSouth())
    .replace('{e}', bounds.getEast())
    .replace('{n}', bounds.getNorth())
  const tileData = await $fetch(requestUrl).then((res) => res.arrayBuffer())

  const [_dataNum, height, width] = new Int32Array(tileData, 0, 3)
  const [w, s, e, n] = new Float32Array(tileData, 4 * 3, 4)
  const uData = clampArray(new Float32Array(tileData, 4 * 8, width * height), -100, 100)
  const vData = clampArray(new Float32Array(tileData, 4 * (8 + width * height), width * height), -100, 100)
  return {
    height,
    width,
    w,
    s,
    e,
    n,
    uData,
    vData
  }
}
